// extracted by mini-css-extract-plugin
export default {"intro":"ModalCerrarCaja_intro__BvTXZ","alert":"ModalCerrarCaja_alert__QFOI2","input":"ModalCerrarCaja_input__Fzu-T"};